var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 120,
    viewBox: "0 0 128 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "57012%",
    x2: "57012%",
    y1: "70331%",
    y2: "24891%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.637,
    height: 119.857,
    fill: "url(#a)",
    opacity: 0.5,
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.596,
    height: 117.431,
    x: 1.022,
    y: 0.881,
    fill: "#FFF",
    stroke: "#E9E9E9",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.519,
    height: 13.907,
    x: 8.781,
    y: 22.513,
    fill: "#047A9C",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.902,
    height: 1.546,
    x: 28.956,
    y: 22.513,
    fill: "#E0E0E0",
    rx: 0.698
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.833,
    height: 1.546,
    x: 28.956,
    y: 27.147,
    fill: "#E0E0E0",
    rx: 0.698
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.519,
    height: 13.907,
    x: 8.781,
    y: 44.144,
    fill: "#047A9C",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.902,
    height: 1.546,
    x: 28.956,
    y: 44.144,
    fill: "#E0E0E0",
    rx: 0.698
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.902,
    height: 1.546,
    x: 28.956,
    y: 48.78,
    fill: "#E0E0E0",
    rx: 0.698
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.519,
    height: 13.907,
    x: 8.781,
    y: 65.777,
    fill: "#047A9C",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.902,
    height: 1.546,
    x: 28.956,
    y: 65.777,
    fill: "#E0E0E0",
    rx: 0.698
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.656,
    height: 1.546,
    x: 28.956,
    y: 70.412,
    fill: "#E0E0E0",
    rx: 0.698
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.443,
    height: 70.451,
    x: 0.039,
    y: 0.141,
    fill: "url(#b)",
    opacity: 0.5,
    rx: 0.701,
    transform: "translate(49.518 38.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76.152,
    height: 68.239,
    x: 50.769,
    y: 39.298,
    fill: "#FFF",
    stroke: "#E9E9E9",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.361,
    height: 14.662,
    x: 58.246,
    y: 53.958,
    fill: "#047A9C",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.177,
    height: 1.629,
    x: 79.516,
    y: 53.958,
    fill: "#E0E0E0",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.177,
    height: 1.629,
    x: 79.516,
    y: 58.845,
    fill: "#E0E0E0",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.083,
    height: 1.629,
    x: 56.61,
    y: 76.584,
    fill: "#E0E0E0",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.083,
    height: 1.629,
    x: 56.61,
    y: 81.471,
    fill: "#E0E0E0",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.083,
    height: 1.629,
    x: 56.61,
    y: 87.988,
    fill: "#E0E0E0",
    rx: 0.701
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.722,
    height: 1.629,
    x: 56.61,
    y: 92.874,
    fill: "#E0E0E0",
    rx: 0.701
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataError);
export default __webpack_public_path__ + "static/media/no-data-error.700c9b69249a6e2c4f635db8edec16b9.svg";
export { ForwardRef as ReactComponent };